import {categoryGroupIdByX, categoryByX} from "../../helpers/categoryHelpers";

export const SET_CATEGORIES = 'SET_CATEGORIES';
export const SET_ACTIVE_CATEGORY = 'SET_ACTIVE_CATEGORY';
export const CLEAR_ACTIVE_CATEGORY = 'CLEAR_ACTIVE_CATEGORY';

// initial state
const state = {
    list: {},
    active: {}
}

// getters
const getters = {
    categories: state => state.list,
    category: state => state.active,
    categorySlugsByGroupId: state => categoryGroupIdByX('slug', state.list),
    categoriesBySlug: state => categoryByX('slug', state.list),
    categoriesById: state => categoryByX('id', state.list),
}

// actions
const actions = {

    getCategories: ({commit, state, dispatch}, payload) => {
        axios.get(laroute.route('api.categories.index'))
            .then((response) => {
                commit(SET_CATEGORIES, {
                    categories: response.data.data
                });
            })
        dispatch('getCategoryGroups')
    },

    setActiveCategory: ({commit, state}, payload) => {
        commit(SET_ACTIVE_CATEGORY, {
            active: payload
        })

    },

    clearActiveCategory: ({commit, state}, payload) => {
        commit(CLEAR_ACTIVE_CATEGORY)

    }
}

// mutations
const mutations = {
    SET_CATEGORIES: (state, payload) => {
        state.list = Object.assign({}, state.list, payload.categories);
    },

    SET_ACTIVE_CATEGORY: (state, payload) => {
        state.active = Object.assign({}, state.active, payload.active);
    },

    CLEAR_ACTIVE_CATEGORY: (state, payload) => {
        state.active = Object.assign({}, state.active, {});
    }
}

export default {
  state,
  getters,
  actions,
  mutations
}
